import { ChangeDetectorRef, Component, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';
import { SelectInstantBaseComponent } from '../selectInstant-base';

@Component({
  selector: 'app-stock-account-presets-select',
  templateUrl: './stock-account-presets-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StockAccountPresetsSelectComponent),
      multi: true
    }
  ]
})
export class StockAccountPresetsSelectComponent extends SelectInstantBaseComponent implements OnInit {
  NotShowInReport: boolean = false;

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef,
    private resueTabService: ReuseTabService
  ) {
    super(http, cdr, router);
    this.valueField = 'id';
  }
  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
  }

  getUrl(searchValue: string): string {
    let url = `api/stockaccountpresets/lookup?$top=50&$skip=0&$orderby=code desc`;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      url = `${url}&$filter=(contains(code, '${encodeURIComponent(
        searchStr
      )}') or contains(name,'${encodeURIComponent(searchStr)}'))`;
    }
    return url;
  }


  // set the location want to navigate
  jump(): string {
    return `stk/account-preset/detail/0`;
  }

  // set the param 
  queryParam(): String {
    return 'StockAccountPresetCode';
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes("report")) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }
}
